import AuthorizationGate from './AuthorizationGate'

export default AuthorizationGate
